var _rect, _rect2, _circle, _rect3, _rect4, _circle2, _rect5, _rect6, _circle3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 300,
    viewBox: "0 0 390 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 68,
    width: 223,
    height: 12,
    rx: 2,
    fill: "#EEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 32,
    width: 149,
    height: 24,
    rx: 2,
    fill: "#EEE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 56,
    r: 24,
    fill: "#EEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 156,
    width: 223,
    height: 12,
    rx: 2,
    fill: "#EEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 120,
    width: 149,
    height: 24,
    rx: 2,
    fill: "#EEE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 144,
    r: 24,
    fill: "#EEE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 244,
    width: 223,
    height: 12,
    rx: 2,
    fill: "#EEE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 208,
    width: 149,
    height: 24,
    rx: 2,
    fill: "#EEE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 232,
    r: 24,
    fill: "#EEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x4i16mpl1a)",
    d: "M0 0h390v398H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "x4i16mpl1a",
    x1: 195,
    y1: -140.205,
    x2: 195,
    y2: 298.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAlarm);
export default __webpack_public_path__ + "static/media/empty_alarm.dccff326006eb3debb910bb0bf6d0bc2.svg";
export { ForwardRef as ReactComponent };